import React, {useState} from "react";
import './Register.css';
import {Button, Heading, Columns, Table} from 'react-bulma-components';
import { Link } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";


const titleStyle = {
    color: 'red',
    padding: '0px -5px 0px -5px',
    margin: '0px 0px 10px 0px',
    fontSize: '5em',
};

function LoginBox() {

    const [inputs, setInputs] = useState({});
    const [userType, setUserType] = useState({});

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(inputs.username);
        console.log(inputs.pass);

        const auth = getAuth();
        signInWithEmailAndPassword(auth, inputs.username, inputs.pass)
            .then((userCredential) => {
                const user = userCredential.user;
                document.cookie = ("Username =" + user["email"]);
                alert("Signed in successfully as " + readCookie("Username"))

                window.location.assign("https://ehet.netlify.app/")

            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode,"->", errorMessage)
                if (errorCode === "auth/user-not-found") {
                    alert("User not found. Please check your Username/Email")
                } else if (errorCode === "auth/wrong-password") {
                    alert("Incorrect Password. Please try again.")
                } else {
                    alert("An error occurred. Please check the fields and try again.")
                }
            });
    }

    return (
        <div className={"fullCardLayoutStyle"}
             style={{width: "50%", minHeight: "500px", height:"40vh", position: "absolute", left: "25%", top: "10%", textAlign: "center",}}>
            <Link to="/"><h1 style={titleStyle}><b>EHET</b></h1></Link>
            <form onSubmit={handleSubmit}>
                <label><b>Email ID</b></label>
                <p><input
                        type="text"
                        className={"inputField"}
                        name="username"
                        value={inputs.username || ""}
                        onChange={handleChange}
                    /></p>
                <p><label><b>Password</b></label></p>
                <p><input
                        type="password"
                        className={"inputField"}
                        name="pass"
                        value={inputs.pass || ""}
                        onChange={handleChange}
                    /></p><br/>
                <p><Button color="info" type="submit" onClick={handleSubmit}>Submit</Button></p>
            </form>
        </div>
    );

}

export default LoginBox;
